import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import DialogActions from 'components/DialogActions';
import SecondaryDialogButton from 'components/SecondaryDialogButton';
import PrimaryDialogButton from 'components/PrimaryDialogButton';
import { Subtitle2, Body2 } from 'components/Typography';
import FileHandler from 'utilities/files';
import { bytesToMb } from 'utilities/formatters/fileSizeFormatter';
import styles from './styles';

class AddEvidenceDialog extends React.Component {

    constructor(props) {
        super(props);

        this.fileRef = React.createRef();
        this.fileHandler = new FileHandler();

        this.state = {
            selectedFile: null,
            errorMessages: [],
            error: false
        };

        this.defaultMessages = {
            fileSize: `Maximum supported file size ${bytesToMb(props.config.maxFileSizeInBytes)}`,
            fileTypes: `Supported file types JPG, or PNG format`
        }
    }

    apply = () => {
        const _this = this;

        this.fileHandler.file = this.state.selectedFile;
        this.fileHandler.readBinaryContents()
            .then(contents => _this.props.handleApply(contents))
            .catch(err => _this.props.handleFileError(err));
    }

    get canApply() {
        return this.state.selectedFile !== null;
    }

    handleFileChange = (event) => {
        if (event.currentTarget.files && event.currentTarget.files.length === 1) {
            const file = event.currentTarget.files[0];
            const errorMessages = [];

            this.setState({
                selectedFile: file,
                errorMessages: errorMessages,
                error: false
            });

            if (file.size > this.props.config.maxFileSizeInBytes) {
                errorMessages.push('fileSize');
                this.setState({
                    selectedFile: null,
                    errorMessages: errorMessages,
                    error: true
                });
            }

            if (!this.props.config.supportedEvidenceFileTypes.includes(file.type)) {
                errorMessages.push('fileTypes');
                this.setState({
                    selectedFile: null,
                    errorMessages: errorMessages,
                    error: true
                });
            }

            if (errorMessages.length === 0) {
                this.props.onFileSelectionChanged(file);
            }
        }
    };

    handleClick = () => {
        this.fileRef.current.click();
    };

    get fileMessage() {
        if (this.state.selectedFile) {
            return this.state.selectedFile.name;
        }

        return "No file selected";
    }

    get validationMessages() {
        const _this = this;
        const { classes } = this.props;
        var content;
        if (!this.state.error) {
            content =
                <Body2 className={this.state.error ? classes.error : ""} >
                    {this.defaultMessages['fileSize']}
                </Body2>;
        } else {
            content = this.state.errorMessages.map((e, index) =>
                <Body2 key={index} className={classes.error}>
                    {_this.defaultMessages[e]}
                </Body2>
            );
        }
        return (content);
    }

    render() {
        const { classes, config } = this.props;
        const fileMessage = this.fileMessage;
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.handleClose}>
                <DialogTitle>
                    Select evidence
                </DialogTitle>
                <DialogContent className={classes.content}>
                    <form>
                        <input
                            type="file"
                            className={classes.offscreen}
                            ref={this.fileRef}
                            id="fileChooser"
                            name="fileChooser"
                            capture="environment"
                            accept={config.supportedEvidenceFileTypes}
                            onChange={this.handleFileChange} />

                        <Grid container justifyContent="flex-start" alignContent="flex-start" spacing={2}>
                            <Grid item>
                                <PrimaryDialogButton onClick={this.handleClick}>Browse</PrimaryDialogButton>
                            </Grid>
                            <Grid item>
                                <Subtitle2>{fileMessage}</Subtitle2>
                            </Grid>
                        </Grid>
                        <Grid container justifyContent="flex-start" alignContent="flex-start" spacing={2}>
                            <Grid item>
                                {this.validationMessages}
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions className={classes.actions}>
                    <SecondaryDialogButton onClick={this.props.handleClose}>Cancel</SecondaryDialogButton>
                    <PrimaryDialogButton disabled={!this.canApply} onClick={this.apply}>Add</PrimaryDialogButton>
                </DialogActions>
            </Dialog>
        );
    }
}

AddEvidenceDialog.propTypes = {
    handleClose: PropTypes.func.isRequired,
    handleApply: PropTypes.func.isRequired,
    handleFileError: PropTypes.func.isRequired,
    onFileSelectionChanged: PropTypes.func.isRequired
};

export default withStyles(styles)(AddEvidenceDialog);